'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { currency } from 'reporting-data/hydrate/numberFormatter';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FALLBACK = '-';
const renderDealCount = count => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `reporting-ui-components.customWidgets.pipelineSnapshots.metrics.DEALS`,
    options: {
      count: Number(count || 0)
    }
  });
};
export const renderCell = (args, amountField) => {
  const {
    column,
    row,
    isFooter
  } = args;
  const count = row.get(`${column.get('field')}`);
  const sum = row.get(`${column.get('field')}_SUM`);
  const currencyCode = column.getIn(['dataset', 'properties', amountField, 'format', 'currencyCode']);
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsxs("td", {
      className: "text-right",
      children: [/*#__PURE__*/_jsx("div", {
        children: isFooter ? /*#__PURE__*/_jsx("b", {
          children: renderDealCount(count)
        }) : /*#__PURE__*/_jsx(Button, {
          onClick: () => column.get('onClick')(args),
          use: "link",
          children: renderDealCount(count)
        })
      }), /*#__PURE__*/_jsx("div", {
        children: currency(sum, {
          currencyCode
        })
      })]
    })
  );
};
export const renderFooterCell = (args, amountField) => {
  const {
    column,
    footer
  } = args;
  return renderCell({
    column,
    row: footer.getIn(['dataset', 'data', '0']),
    isFooter: true
  }, amountField);
};

//function used in pipeline snapshots to render the row of deal activity
export const renderDealActivity = args => {
  const {
    column,
    row
  } = args;
  const label = row.get(column.get('field'));
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx("td", {
      className: "text-right",
      children: label ? /*#__PURE__*/_jsx(Button, {
        onClick: () => column.get('onClick')(args),
        use: "link",
        children: label
      }) : FALLBACK
    })
  );
};
export const renderDealActivityHeader = () =>
/*#__PURE__*/
/* @bend-expect trellis-tokenized */
_jsx("td", {
  className: "text-left",
  children: /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-ui-components.customWidgets.pipelineSnapshots.properties.pipeline_summary"
    }), /*#__PURE__*/_jsx(Tooltip, {
      use: "longform",
      placement: "bottom",
      maxInlineSize: "200px",
      title: I18n.text('reporting-ui-components.customWidgets.pipelineSnapshots.summaryTooltip'),
      children: /*#__PURE__*/_jsx(HelpIcon, {
        name: "info",
        size: "300",
        marginInlineStart: "200"
      })
    }), /*#__PURE__*/_jsx(Badge, {
      use: "new",
      marginInlineStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-ui-components.customWidgets.pipelineSnapshots.new"
      })
    })]
  })
});
export const renderTotalHeader = () =>
/*#__PURE__*/
/* @bend-expect trellis-tokenized */
_jsx("td", {
  className: "text-left",
  children: /*#__PURE__*/_jsx("b", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-ui-components.customWidgets.pipelineSnapshots.totalLabel"
    })
  })
});
export const CUSTOM_FIELD_RENDERS = {
  Total: renderTotalHeader,
  deal_activity: renderDealActivityHeader
};
export const CUSTOM_FIELD_KEYS = Object.keys(CUSTOM_FIELD_RENDERS);